const ANONYMOUS_CART_KEY = 'temporary_cart';
const isLocalStorageAvailable = () => typeof window !== 'undefined' && !!window.localStorage;
const isCookieAvailable = () => typeof document !== 'undefined' && !!document.cookie;
const hasCartIdInLocalStorage = () => isLocalStorageAvailable() && !!window.localStorage.getItem(ANONYMOUS_CART_KEY);
export const hasCartIdInCookie = () => isCookieAvailable() && document.cookie.split(';').some(item => item.trim().startsWith(`${ANONYMOUS_CART_KEY}=`));
export const hasCartId = () => hasCartIdInLocalStorage() || hasCartIdInCookie();
const getLocalStorageCartId = () => hasCartIdInLocalStorage() ? window.localStorage.getItem(ANONYMOUS_CART_KEY) : '';
const getCookieCartId = () => hasCartIdInCookie() ? document.cookie.split('; ').find(row => row.startsWith(`${ANONYMOUS_CART_KEY}=`)).split('=')[1] : '';
export const getCartId = () => getLocalStorageCartId() || getCookieCartId();
export const setCartIdToCookies = cartId => {
  if (isCookieAvailable()) {
    const cookieDomain = window.location.host.replace(/.*?\./, '');
    document.cookie = `${ANONYMOUS_CART_KEY}=${cartId};domain=${cookieDomain};sameSite=Lax;secure;path=/`;
  }
};
export const setCartId = cartId => {
  try {
    if (isLocalStorageAvailable()) {
      window.localStorage.setItem(ANONYMOUS_CART_KEY, cartId);
    }
  } catch (err) {}
  setCartIdToCookies(cartId);
};
export const clearCartId = () => {
  if (hasCartIdInLocalStorage()) {
    window.localStorage.removeItem(ANONYMOUS_CART_KEY);
  }
  if (hasCartIdInCookie()) {
    setCartIdToCookies('');
  }
};